import { useEffect, useState } from 'react';

export const useSettingsPageLoadingGate = (routeKey: string, ready: boolean): boolean => {
  const [activeRouteKey, setActiveRouteKey] = useState(routeKey);
  const [routePainted, setRoutePainted] = useState(false);
  const routeChanged = activeRouteKey !== routeKey;

  useEffect(() => {
    if (!routeChanged) return;
    setActiveRouteKey(routeKey);
    setRoutePainted(false);
  }, [routeChanged, routeKey]);

  useEffect(() => {
    if (routeChanged || routePainted) return;
    const frameId = window.requestAnimationFrame(() => {
      setRoutePainted(true);
    });
    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [routeChanged, routePainted]);

  return routeChanged || !routePainted || !ready;
};
